// Helper class for Data formatting.


export const _toLocStringDate = (sDateObj) => {

    let result = new Date(sDateObj).toLocaleDateString();

    return(result);
}